<template>
  <div>
    <div>Broker ref is not valid please check url</div>
  </div>
</template>

<script>
export default {
  name: 'InvalidQuote',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
}
</script>

<style lang="scss" scoped></style>
